import { userRole } from "./storage";

export const getBasePathByUserRole = () => {
    return userRole === "Admin"
      ? "/admin"
      : userRole === "CMO"
      ? "/cmo"
      : userRole === "MD"
      ? "/md"
      : userRole === "BOD"
      ? "/bod"
      : null;
  };
  